export default __webpack_public_path__ + "img/sagoo/seq/sagoo2_480.webp";